import dispatcher from './dispatcher';
import { BASE_URL } from './AppConst';
import axios from 'axios';
import { VIEW_QUESTIONS, DISMISS, ON_ERROR } from './Actions';

export const ViewQuestions = async () => {
  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.common['Authorization'] = localStorage.getItem(
    'app_token'
  );

  try {
    const response = await axios.get('/questions');
    if (response.data) {
      dispatcher.dispatch({
        type: VIEW_QUESTIONS,
        payload: response.data,
      });
    } else {
      dispatcher.dispatch({
        type: VIEW_QUESTIONS,
        payload: [],
      });
    }
  } catch (err) {
    dispatcher.dispatch({
      type: ON_ERROR,
      payload: err,
    });
  }
};

export const DeleteQuestion = async (postData, isDeleteAll) => {

  const { id } = postData;

  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.common['Authorization'] = localStorage.getItem(
    'app_token'
  );

  try {
    const response = isDeleteAll ? await axios.delete('/questions-all') : await axios.delete('/question/' + id) ;

    if (response.data) {
      dispatcher.dispatch({
        type: VIEW_QUESTIONS,
        payload: response.data,
      });
    } else {
      dispatcher.dispatch({
        type: VIEW_QUESTIONS,
        payload: [],
      });
    }
  } catch (error) {
    dispatcher.dispatch({
      type: ON_ERROR,
      payload: error,
    });
  }
};

export function DissMiss() {
  dispatcher.dispatch({
    type: DISMISS,
  });
}
